import { createContext, useState, useEffect, useContext } from 'react';
import API from '@api/api';
import { AppContext } from '@utils/AppContext';

export const MaterialManageContext = createContext();

export const MaterialManageContextProvider = ({ children }) => {
    // 左侧菜单相关
    const [menuList, setMenuList] = useState([]) // 菜单列表
    const [activeMenu, setActiveMenu] = useState(null) // 当前选中的菜单
    const [activeMenuName, setActiveMenuName] = useState('全部参考图') // 当前选中的菜单名称

    // 右侧列表相关
    const [materialList, setMaterialList] = useState([]) // 素材列表
    const [total, setTotal] = useState(0) // 素材总数
    const [loading, setLoading] = useState(false) // 加载状态
    const [searchKeyword, setSearchKeyword] = useState('') // 搜索关键词

    // 批量操作
    const [batchMode, setBatchMode] = useState(false) // 是否批量操作模式
    const [selectedList, setSelectedList] = useState([]) // 已选中的素材

    return (
        <MaterialManageContext.Provider value={{
            menuList, setMenuList,
            activeMenu, setActiveMenu,
            activeMenuName, setActiveMenuName,
            materialList, setMaterialList,
            total, setTotal,
            loading, setLoading,
            searchKeyword, setSearchKeyword,
            batchMode, setBatchMode,
            selectedList, setSelectedList,
        }}>
            {children}
        </MaterialManageContext.Provider>
    );
};